const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const BatchProcessTrackingQueryURL = {
    GetItems: Backofficebff + '/v1/batch-process-tracking/items',
    GetMetrics: Backofficebff + '/v1/batch-process-tracking/metrics',
    GetDetail: Backofficebff + '/v1/batch-process-tracking/detail',
    GetHistory: Backofficebff + '/v1/batch-process-tracking/history',
    GetBarcodeProductionSummary: Backofficebff + '/v1/batch-process-tracking/barcode-production-summary',
    GetBarcodeProductionSummaries: Backofficebff + '/v1/batch-process-tracking/barcode-production-summaries',
    GetBarcodeProductionHistory: Backofficebff + '/v1/batch-process-tracking/barcode-production-history',
    GetCreatedByOptions: Backofficebff + '/v1/batch-process-tracking/created-by-options',
    GetStatusOptions: Backofficebff + '/v1/batch-process-tracking/status-options',
};
